import { EbisInterfaceMonitoringMaintenanceConstant } from "presentation/constant/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceConstant";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";

export const EbisInterfaceMonitoringHeaderPanel = () => {

    const [ebisInterfaceMonitoringState] = useEbisInterfaceMonitoringMaintenanceTracked();
    const { currentSelectedRow } = ebisInterfaceMonitoringState;
    const HDR_CONST = EbisInterfaceMonitoringMaintenanceConstant;

    return <>
        <div className="headerInfo">
            <div className="fourColumns">
                <div className={"item"}>
                    <div className={"label"}>
                        {HDR_CONST.MESSAGE_TYPE}
                    </div>
                    <div className={"value"}>
                        {currentSelectedRow?.messageType as string}
                    </div>
                </div>

                <div className={"item"}>
                    <div className={"label"}>
                        {HDR_CONST.FROM}
                    </div>
                    <div className={"value"}>
                        {currentSelectedRow?.from as string}
                    </div>
                </div>

                <div className={"item"}>
                    <div className={"label"}>
                        {HDR_CONST.TO}
                    </div>
                    <div className={"value"}>
                        {currentSelectedRow?.to as string}
                    </div>
                </div>

                <div className={"item"}>
                    <div className={"label"}>
                        {HDR_CONST.FILE_NAME}
                    </div>
                    <div className={"value"}>
                        {currentSelectedRow?.filename as string}
                    </div>
                </div>

            </div>
        </div>
    </>
}